import { Select } from '@adtech/ui';
import React from 'react';

interface IProps {
    value: string;
    setValue: (value: EAccessValues) => void;
    disabled?: boolean;
    className?: string;
    size?: 'large' | 'middle' | 'small';
}

export enum EAccessValues {
    view = 'view',
    edit = 'edit',
}

const PermissionSelect: React.FC<IProps> = ({
    disabled = false,
    value,
    setValue,
    className = '',
    size = 'middle',
}: IProps) => {
    const items = [
        {
            label: 'Только просмотр',
            value: EAccessValues.view,
        },
        {
            label: 'Редактирование',
            value: EAccessValues.edit,
        },
    ];

    return (
        <Select
            wrapperClassName={className}
            value={value}
            options={items}
            size={size}
            onChange={setValue}
            disabled={disabled}
        />
    );
};

export default PermissionSelect;
